<template>
  <div ref="root">
    <HirePanel
      v-if="selectedHireId"
      :hire-id="selectedHireId"
      :back-label="$t('All hires')"
      :custom-fields-answered-by="AccountType.Worker"
      data-test="compliance-review-hire-panel"
      @back="selectedHireId = null"
    />

    <ComplianceHiresSection
      v-show="!selectedHireId"
      :trusted-contact-id="trustedContactId"
      @select="selectedHireId = $event"
      @count="emit('count', $event)"
    />
  </div>
</template>

<script lang="ts" setup>
import { nextTick, ref, watch } from 'vue'
import ComplianceHiresSection from '@/components/compliances/ComplianceReviewModal/ComplianceHiresSection.vue'
import HirePanel from '@/components/Hire/HirePanel.vue'
import { AccountType } from '@/gql/graphql'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'

defineProps<{
  trustedContactId: string
}>()

const emit = defineEmits<{ count: [count: number] }>()

// The list stays mounted behind the panel, so going back keeps the Ended group as it was left.
const selectedHireId = ref<string | null>(null)

const root = ref<HTMLElement | null>(null)

let listScroll = 0

// The rail around this pane scrolls, so each view starts where it should: a hire at the top, the list where it was left.
watch(selectedHireId, async (id, previous) => {
  const scroller = root.value?.parentElement
  if (!scroller) return

  if (previous === null) listScroll = scroller.scrollTop

  await nextTick()
  scroller.scrollTop = id ? 0 : listScroll
})
</script>
